import { SetCoinFromAction, SetCoinToAction, SetLastCoinChangedAction } from '../reducers'

const setSelectedCoinsWithAmounts = (
    coinPairServerDto,
    dispatchSelectedCoins,
    changedCoinInputType = null,
) => {
    const {
        pair,
        amount_quote,
        amount_base,
        min_amount_base,
        max_amount_base,
        min_amount_quote,
        max_amount_quote,
    } = coinPairServerDto

    if (changedCoinInputType) {
        dispatchSelectedCoins(new SetLastCoinChangedAction(changedCoinInputType))
    }

    dispatchSelectedCoins(
        new SetCoinFromAction({
            code: pair?.quote,
            amount: amount_quote,
            minAmount: min_amount_quote,
            maxAmount: max_amount_quote,
        }),
    )

    dispatchSelectedCoins(
        new SetCoinToAction({
            code: pair?.base,
            amount: amount_base,
            minAmount: min_amount_base,
            maxAmount: max_amount_base,
        }),
    )
}

export { setSelectedCoinsWithAmounts }
